import LegalLayout from './LegalLayout.jsx'

const UPDATED_AT = '21 de outubro de 2026'

const SECTIONS = [
  { id: 'plataforma', title: '1. Pela plataforma' },
  { id: 'email', title: '2. Por e-mail' },
  { id: 'meta', title: '3. Removi o app pelo Facebook' },
  { id: 'o-que-removemos', title: '4. O que é removido' },
]

export default function DataDeletion() {
  return (
    <LegalLayout
      eyebrow="Exclusão de dados"
      title="Instruções de exclusão de dados"
      updatedAt={UPDATED_AT}
      sections={SECTIONS}
    >
      <section id="plataforma">
        <h2>
          <span className="legal-num">01</span> Pela plataforma
        </h2>
        <p>
          Entre na TITAM, abra <strong>Configurações → Meu perfil</strong> e use{' '}
          <strong>Excluir conta</strong>. A conta e os acessos são removidos permanentemente.
        </p>
      </section>

      <section id="email">
        <h2>
          <span className="legal-num">02</span> Por e-mail
        </h2>
        <p>
          Envie um e-mail para <a href="mailto:deebsnow.io@gmail.com">deebsnow.io@gmail.com</a> com o
          assunto "Exclusão de dados", a partir do e-mail cadastrado na TITAM (ou informando o e-mail ou
          telefone do lead, caso a solicitação seja sobre um contato captado por anúncio). Atendemos a
          solicitação em até 30 dias.
        </p>
      </section>

      <section id="meta">
        <h2>
          <span className="legal-num">03</span> Removi o app pelo Facebook
        </h2>
        <p>
          Ao remover a TITAM em <strong>Configurações do Facebook → Integrações comerciais</strong>, a
          Meta deixa de permitir novos acessos e o token de acesso é descartado. Os dados já gravados no
          CRM não são apagados automaticamente: para excluí-los, siga um dos passos acima.
        </p>
      </section>

      <section id="o-que-removemos">
        <h2>
          <span className="legal-num">04</span> O que é removido
        </h2>
        <ul>
          <li>Dados de cadastro e de acesso;</li>
          <li>Tokens de acesso da Meta e do Google;</li>
          <li>Dados obtidos das integrações (campanhas, leads e conversas de anúncios);</li>
        </ul>
        <p>
          Podemos reter apenas o que a lei exigir, pelo prazo legal. Detalhes na{' '}
          <a href="/privacy">Política de Privacidade</a>.
        </p>
      </section>
    </LegalLayout>
  )
}
